module.exports = __webpack_public_path__ + "img/stop-hsa-signup-partab-3m-before-retire.9b6a537.png";